module.exports = __webpack_public_path__ + "static/media/ni.baafd7d7.svg";